import { Component, Input } from '@angular/core';
import { TExcelContext } from '@monorepo/types';
import { TUploadResponseDTO } from '@monorepo/services';
import { ExcelManagementFacade } from '../../../../redux-store';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'monorepo-upload-summary-modal',
  templateUrl: './upload-summary-modal.component.html',
  styleUrls: ['./upload-summary-modal.component.scss'],
})
export class UploadSummaryModalComponent {
  @Input() excelContext!: TExcelContext;

  @Input() summary: TUploadResponseDTO = {
    totalProcessedRows: 0,
    successfulRows: 0,
    failedRows: 0,
    errors: 0,
  };

  constructor(private excelManagementFacade: ExcelManagementFacade, private modalController: ModalController) {}

  onDownloadErrorFile() {
    const errorFileKeyOpt = this.summary?.errorFileKeyOpt;
    if (errorFileKeyOpt) {
      this.excelManagementFacade.downloadErrorTemplate(errorFileKeyOpt, this.excelContext);
      this.dimissModal();
    }
  }

  dimissModal() {
    this.modalController.dismiss();
  }
}
